import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// reducer import
import customizationReducer from './customizationReducer';
import accountReducer from './accountReducer';
import reportReducer from './slices/report';
import snackbarReducer from './slices/snackbar';
import adminReducer from './slices/admin';

//-----------------------|| COMBINE REDUCER ||-----------------------//

const reducer = combineReducers({
    account: persistReducer(
        {
            key: 'account',
            storage,
            keyPrefix: 'berry-'
        },
        accountReducer
    ),
    admin: persistReducer(
        {
            key: 'admin',
            storage,
            keyPrefix: 'berry-'
        },
        adminReducer
    ),
    customization: customizationReducer,
    report: reportReducer,
    snackbar: snackbarReducer,
});

export default reducer;
